export const ds_VideoBlock_Entry = `
    fragment ds_VideoBlock_Entry on ds_VideoBlock_Entry {
        id
        canonicalUid
        video_ColorPalette
        video_ColorTheme
        video_TopSpacing
        video_ContainerWidth
        video_FullWidthBackground
        video_Text
        video_TextPosition
        video_CoverImage {
            url @transform(width: 1280, height: 720)
            title
            alt
            focalPoint
        }
        video_Video {
            ... on ds_VideosSection_Entry {
                title
                videoUrl
                videoType
                url
                videoFile {
                    url
                }
            }
        }
    }
`
